import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/mmt/logo.png";
import prelogin from "../../assets/images/mmt/prelogin.png";
import resetBg from "../../assets/images/mmt/bg-reset-password.png";
import { requestPasswordReset, resetPassword } from "../mmtUserList/mmtApi";
import { pageLocale } from "../../utlis/locale";
import "./mmtlogin.scss";

const STEPS = { EMAIL: "email", RESET: "reset", SUCCESS: "success" };
const EMAIL_REGEX = /^\s*[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,}\s*$/i;

export default function MmtForgotPasswordFlow() {
  const navigate = useNavigate();
  const location = useLocation();
  const t = pageLocale("mmtForgot");
  const initialEmail = location.state?.email || "";
  const autoSend = Boolean(location.state?.autoSend && initialEmail);
  const [step, setStep] = useState(STEPS.EMAIL);
  const [email, setEmail] = useState(initialEmail);
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async (fn) => {
    setLoading(true);
    setError("");
    try {
      await fn();
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || t.error_generic);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!autoSend) return;

    run(async () => {
      await requestPasswordReset(initialEmail);
      setStep(STEPS.RESET);
    });
  }, [autoSend, initialEmail]);

  const submitEmail = (event) => {
    event.preventDefault();
    const trimmed = email.trim();
    if (!EMAIL_REGEX.test(trimmed)) {
      setError(t.error_invalid_email);
      return;
    }
    run(async () => {
      await requestPasswordReset(trimmed);
      setStep(STEPS.RESET);
    });
  };

  const submitReset = (event) => {
    event.preventDefault();
    if (!otp.trim()) {
      setError(t.error_missing_code);
      return;
    }
    if (password.length < 8) {
      setError(t.error_password_length);
      return;
    }
    if (password !== confirm) {
      setError(t.error_password_mismatch);
      return;
    }
    run(async () => {
      await resetPassword({ email: email.trim(), otp: otp.trim(), password });
      setStep(STEPS.SUCCESS);
      window.setTimeout(() => navigate("/login", { replace: true }), 1200);
    });
  };

  return (
    <main className="mmt-login-page">
      <section className="mmt-login-scroll">
        <div className="mmt-login-shell">
          <div className="mmt-login-art">
            <img src={logo} alt="Senior Life" className="mmt-login-logo" />
            <img src={prelogin} alt="" className="mmt-login-prelogin" />
          </div>

          {step === STEPS.EMAIL ? (
            <form className="mmt-login-card" onSubmit={submitEmail}>
              <h1>{t.title}</h1>
              {error ? <div className="mmt-login-error">{error}</div> : null}
              <label className="mmt-field">
                <span>{t.email_label}</span>
                <input
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError("");
                  }}
                  inputMode="email"
                  autoComplete="email"
                  disabled={loading}
                />
              </label>
              <button
                className="mmt-primary-button"
                type="submit"
                disabled={loading}
              >
                {loading ? t.sending : t.send_code}
              </button>
              <p className="mmt-new-user">
                <Link to="/login">{t.back_to_login}</Link>
              </p>
            </form>
          ) : null}

          {step === STEPS.RESET ? (
            <form className="mmt-login-card" onSubmit={submitReset}>
              <h1>{t.reset_title}</h1>
              <p>{t.code_sent.replace("{email}", email.trim())}</p>
              {error ? <div className="mmt-login-error">{error}</div> : null}
              <label className="mmt-field">
                <span>{t.code_label}</span>
                <input
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  inputMode="numeric"
                  disabled={loading}
                />
              </label>
              <label className="mmt-field">
                <span>{t.new_password}</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </label>
              <label className="mmt-field">
                <span>{t.confirm_password}</span>
                <input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  disabled={loading}
                />
              </label>
              <button
                className="mmt-primary-button"
                type="submit"
                disabled={loading}
              >
                {loading ? t.saving : t.submit}
              </button>
            </form>
          ) : null}

          {step === STEPS.SUCCESS ? (
            <div className="mmt-login-card">
              <h1>{t.success_title}</h1>
              <p>{t.success_subtitle}</p>
            </div>
          ) : null}
        </div>
      </section>
      <img src={resetBg} alt="" className="mmt-login-bg" />
    </main>
  );
}
